import { Controller } from '@hotwired/stimulus';
export default class extends Controller {
    connect() {
        const ancestor = document.querySelector('.savanna-ascension > .image');
        setTimeout(function () {
            ancestor === null || ancestor === void 0 ? void 0 : ancestor.remove();
        }, 3500);
    }
}
